import { Dropdown, Avatar } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { logoutAction } from "../../../redux/actions/authActions";
import cardBg2 from "../../../assets/images/dashboard/ecommerce-card-bg.png";
import { useTranslation } from "react-i18next";
import { User, CreditCard, Globe, LogOut } from "lucide-react";

const HeaderUser = ({ placement }) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { t } = useTranslation();

  const handleLogout = () => {
    dispatch(logoutAction());
  };

  const menuItems = [
    {
      key: "profile",
      icon: <User size={16} />,
      label: t("navigation.footer.myProfile"),
      to: "/profile/information",
    },
    ...(user?.role === "admin"
      ? [
          {
            key: "subscription",
            icon: <CreditCard size={16} />,
            label: t("navigation.footer.mySubscription"),
            to: "/profile/subscription",
          },
          {
            key: "language",
            icon: <Globe size={16} />,
            label: t("navigation.footer.language"),
            to: "/profile/language",
          },
        ]
      : []),
    {
      key: "logout",
      icon: <LogOut size={16} />,
      label: t("navigation.footer.logout"),
      onClick: handleLogout,
      danger: true,
    },
  ];

  const dropdownContent = (
    <div
      style={{
        background: "#fff",
        borderRadius: "12px",
        boxShadow: "0 4px 24px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.05)",
        padding: "6px",
        minWidth: "200px",
      }}
    >
      {/* User Info Header */}
      <div
        style={{
          padding: "12px",
          borderBottom: "1px solid #f0f0f0",
          marginBottom: "6px",
        }}
      >
        <div style={{ fontWeight: 600, color: "#1a1a1a", fontSize: "14px" }}>
          {user?.name}
        </div>
        <div style={{ color: "#666", fontSize: "12px", marginTop: "2px" }}>
          {user?.email}
        </div>
      </div>

      {/* Menu Items */}
      {menuItems.map((item) => {
        const content = (
          <div
            key={item.key}
            onClick={item.onClick}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              padding: "10px 12px",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.15s ease",
              color: item.danger ? "#dc2626" : "#374151",
              fontSize: "14px",
              fontWeight: 500,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = item.danger ? "#fef2f2" : "#f5f5f5";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "transparent";
            }}
          >
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "20px",
                height: "20px",
                color: item.danger ? "#dc2626" : "#6b7280",
              }}
            >
              {item.icon}
            </span>
            <span>{item.label}</span>
          </div>
        );

        if (item.to) {
          return (
            <Link key={item.key} to={item.to} style={{ textDecoration: "none" }}>
              {content}
            </Link>
          );
        }
        return content;
      })}
    </div>
  );

  return (
    <Dropdown
      overlay={dropdownContent}
      placement={placement}
      trigger={["hover", "click"]}
      overlayStyle={{ zIndex: 1050 }}
    >
      <div style={{ cursor: "pointer" }}>
        <Avatar
          size={48}
          style={{
            backgroundColor: "#B4DAFD",
            backgroundImage: `url(${cardBg2})`,
            backgroundSize: "cover",
            backgroundPosition: "center right",
            color: "#1a56db",
            fontWeight: 600,
            fontSize: "16px",
          }}
        >
          {user?.name?.charAt(0).toUpperCase()}
          {user?.name?.charAt(user?.name?.length - 1).toUpperCase()}
        </Avatar>
      </div>
    </Dropdown>
  );
};

export default HeaderUser;
